import { Box, Dialog, DialogContent, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FreeMode, Navigation, Pagination, Thumbs, Zoom } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CloseIcon from "@mui/icons-material/Close";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/zoom";
import "./styles.css";

import { useDispatch, useSelector } from "react-redux";
import { handleFullscreen } from "./carousalSlice";

const SwiperCarousal = ({ swiperOnCard, data, heightMob, heightDesk }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const isMob = useSelector((state) => state.global.isMobile);
  const dispatch = useDispatch();
  //get fullscreen state from redux store to handle 360 degree fullscreen
  const isFullScreen = useSelector((state) => state.carousal.fullscreen);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper?.realIndex);
  };

  return (
    <>
      {!swiperOnCard ? (
        <Box
          sx={{
            position: "relative",
            "& .swiper-slide-thumb-active": {
              outline: "3px solid #85C0FF",
              outlineOffset: "-3px",
              borderRadius: { md: ".5rem", xs: ".5rem" },
              transform: "scale(.95)",
            },
            "& .swiper-slide img": {
              borderRadius: { xs: ".5rem", md: "1rem" },
            },
          }}
        >
          <Tooltip title="Fullscreen">
            <IconButton
              sx={{
                position: "absolute",
                top: "1rem",
                right: "1rem",
                zIndex: 9,
                background: "#fff",
                "&:hover": { background: "#e0e0e0" },
              }}
              color="appBlue"
              onClick={() => dispatch(handleFullscreen())}
            >
              <FullscreenIcon />
            </IconButton>
          </Tooltip>
          <Swiper
            dir="ltr"
            onSwiper={setThumbsSwiper}
            // onSlideChange={handleSlideChange}
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            spaceBetween={10}
            navigation={true}
            grabCursor={true}
            thumbs={{
              swiper:
                thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
            }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper2"
          >
            {data?.map((image, index) => (
              <SwiperSlide key={index} className="mainSlider">
                <img src={image} width={"100%"} height={"auto"} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Swiper
            dir="ltr"
            onSwiper={setThumbsSwiper}
            spaceBetween={10}
            slidesPerView={isMob ? 4 : 8}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[Thumbs]}
            className="mySwiper"
          >
            {data?.map((image, index) => (
              <SwiperSlide key={index}>
                <img src={image} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      ) : (
        <Swiper
          dir="ltr"
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
          }}
          spaceBetween={10}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper2"
        >
          {data?.map((image, index) => (
            <SwiperSlide key={index} className="mainSlider">
              <img src={image} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      <Dialog
        maxWidth="xl"
        sx={{
          "& .MuiDialog-paper": {
            height: "100vh",
            margin: 0,
            maxHeight: "none",
            width: "100%",
            maxWidth: "100%",
          },
        }}
        fullScreen={!!isFullScreen}
        open={!!isFullScreen}
        onClose={handleFullscreen}
      >
        <Tooltip title="Exit fullscreen">
          <IconButton
            sx={{
              position: "fixed",
              top: "1rem",
              right: "1rem",
              zIndex: 9,
              background: "#fff",
              "&:hover": { background: "#e0e0e0" },
            }}
            color="appBlue"
            onClick={() => dispatch(handleFullscreen())}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <Box
          sx={{
            height: "100vh",
            "& .swiper": {
              width: "100%",
              height: "100%",
            },
            "& .swiper-slide": {
              textAlign: "center",
              fontSize: "18px",
              background: "#fff",

              /* Center slide text vertically */
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "& img": {
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: { xs: "contain", md: "cover" },
              },
            },
          }}
        >
          <Swiper
            dir="ltr"
            navigation={true}
            modules={[Navigation, Zoom]}
            className="mySwiper2"
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            loop={true}
            zoom={true}
          >
            {data.map((image, index) => (
              <SwiperSlide key={index}>
                <div className="swiper-zoom-container">
                  <img src={image} alt={`Fazaa used cars image${index}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Dialog>
    </>
  );
};

export default SwiperCarousal;
